export var TooltipVariant = /*#__PURE__*/ function(TooltipVariant) {
    TooltipVariant["default"] = "default";
    TooltipVariant["info"] = "info";
    TooltipVariant["error"] = "error";
    TooltipVariant["warning"] = "warning";
    TooltipVariant["success"] = "success";
    return TooltipVariant;
}({});
